import subjects from './subjects';

const composers = { subjects };

export default composers;
